import axios from "../../axiosInstance/axiosInstance";
import apiUrlOne from "../../utils.js/Config";

/* Fetch all blog categories */
export const getAllBlogCategories = async () => {
    try {
        const response = await axios.get(`${apiUrlOne}/blog-categories`);
        return response.data;
    } catch (error) {
        console.error("Error fetching blog categories:", error);
        throw error;
    }
};

/* Create blog category */
export const createBlogCategory = async (formData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/blog-categories`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating blog category:", error);
        throw error;
    }
};

/* Get blog category by ID */
export const getBlogCategoryById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/blog-categories/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching blog category with ID ${id}:`, error);
        throw error;
    }
};

/* Update blog category */
export const updateBlogCategory = async (id, formData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/blog-categories/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating blog category with ID ${id}:`, error);
        throw error;
    }
};

/* Delete blog category */
export const deleteBlogCategory = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/blog-categories/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting blog category with ID ${id}:`, error);
        throw error;
    }
};


// --------------------------------------------------------------------------
// BLOGS (ARTICLES)

/* Fetch all blogs with search, pagination and type filter */
export const getAllBlogs = async (search = '', page = 1, limit = 10, type = '') => {
    try {
        let url = `${apiUrlOne}/blogs/admin/my-blogs?search=${search}&page=${page}`;
        if (limit !== undefined && limit !== 10) {
            url += `&limit=${limit}`;
        }
        if (type) {
            url += `&type=${type}`;
        }
        const response = await axios.get(url);
        return response.data;
    } catch (error) {
        console.error("Error fetching blogs:", error);
        throw error;
    }
};

/* Create blog */
export const createBlog = async (formData) => {
    try {
        const response = await axios.post(`${apiUrlOne}/blogs`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error creating blog:", error);
        throw error;
    }
};

/* Get blog by ID */
export const getBlogById = async (id) => {
    try {
        const response = await axios.get(`${apiUrlOne}/blogs/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching blog with ID ${id}:`, error);
        throw error;
    }
};

/* Update blog */
export const updateBlog = async (id, formData) => {
    try {
        const response = await axios.put(`${apiUrlOne}/blogs/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
        return response.data;
    } catch (error) {
        console.error(`Error updating blog with ID ${id}:`, error);
        throw error;
    }
};

/* Delete blog */
export const deleteBlog = async (id) => {
    try {
        const response = await axios.delete(`${apiUrlOne}/blogs/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error deleting blog with ID ${id}:`, error);
        throw error;
    }
};
